// Catfishing / Romance behavioral screening question bank.
// Extracted verbatim from the pre-refactor RomanceAssessment.js so the
// screening logic is unchanged; shape: { question, weight, options[{text, points}] }.
// Multi-select questions are flagged by '(Select all that apply)' in the text.
export const CATFISHING_ROMANCE_QUESTIONS = [
  {
    question: "Describe how your online relationship started?",
    weight: 5,
    options: [
      { text: "I saw his/her online profile and I sent a friend request.", points: 2 },
      { text: "Received an unsolicited email, text request or direct message request.", points: 5 },
      { text: "A trusted online friend introduced?", points: 1 }
    ]
  },
  {
    question: "Current length of time of your current online relationship?",
    weight: 5,
    options: [
      { text: "0 - 3 months", points: 5 },
      { text: "3 months - 6 months", points: 5 },
      { text: "7 months - 11 months", points: 4 },
      { text: "12+ Months", points: 3 }
    ]
  },
  {
    question: "At any point has your digital partner asked for or you have given ANY financial help for family or financial emergencies? If so at what stage of the relationship did that happen?",
    weight: 5,
    options: [
      { text: "0 - 3 months", points: 5 },
      { text: "3 months - 6 months", points: 5 },
      { text: "7 months - 11 months", points: 5 },
      { text: "12+ Months", points: 5 },
      { text: "Never asked", points: 1 }
    ]
  },
  {
    question: "Has your digital partner discussed or introduced the benefits of making a small investing in bitcoin or other digital currencies?",
    weight: 5,
    options: [
      { text: "Yes, it's part of our conversation. He/she thinks could help me make easy money.", points: 5 },
      { text: "No, never come up", points: 1 }
    ]
  },
  {
    question: "Has your digital partner offered to coach or otherwise help you understand investing in bitcoin or digital currency?",
    weight: 5,
    options: [
      { text: "Yes", points: 5 },
      { text: "No", points: 1 }
    ]
  },
  {
    question: "Have you or your online partner shared details about a significant emotional or financial event?",
    weight: 3,
    options: [
      { text: "Yes", points: 5 },
      { text: "No", points: 1 }
    ]
  },
  {
    question: "Which best describe the primary focus of your conversation with your digital partner?",
    weight: 3,
    options: [
      { text: "Mostly talk about his family, passions, career and life experience.", points: 5 },
      { text: "He/she like me to share about my family, dreams, passions, career and life experience.", points: 3 }
    ]
  },
  {
    question: "Does your conversation focus on travel, music, dining out, comedy, etc?",
    weight: 3,
    options: [
      { text: "Yes", points: 3 },
      { text: "No", points: 1 }
    ]
  },
  {
    question: "Have you and your digital partner shared religious, political and moral beliefs?",
    weight: 3,
    options: [
      { text: "Yes", points: 3 },
      { text: "No", points: 1 }
    ]
  },
  {
    question: "At what stage has your digital partner profess romance feeling of love for you?",
    weight: 3,
    options: [
      { text: "0 - 3 months", points: 5 },
      { text: "3 months - 6 months", points: 5 },
      { text: "7 months - 11 months", points: 4 },
      { text: "12+ Months", points: 3 },
      { text: "Has not professed any feeling", points: 1 }
    ]
  },
  {
    question: "Have you professed romance feeling for your online partner? If so what time period?",
    weight: 3,
    options: [
      { text: "0 - 3 months", points: 5 },
      { text: "3 months - 6 months", points: 5 },
      { text: "7 months - 12 months", points: 4 },
      { text: "12+ Months", points: 3 },
      { text: "Have not professed any feeling", points: 1 }
    ]
  },
  {
    question: "Have you and your 'love interest' made plans for a get-away trip?",
    weight: 3,
    options: [
      { text: "We're planning one right now.", points: 3 },
      { text: "Yes, but something happens last minute causing cancellation.", points: 5 },
      { text: "We've done a couple of weekends together.", points: 1 }
    ]
  },
  {
    question: "As your relationship has deepened were you encouraged to switch to use these messaging app? (Select all that apply)",
    weight: 20,
    options: [
      { text: "WhatsApp", points: 5 },
      { text: "Google Hangout", points: 5 },
      { text: "Telegram", points: 5 },
      { text: "Other Encrypted Message apps", points: 5 }
    ]
  },
  {
    question: "Have you shared personal contact information with your digital partner (Cell, Email or other personal information)?",
    weight: 3,
    options: [
      { text: "Yes", points: 5 },
      { text: "No, not at this time.", points: 1 }
    ]
  },
  {
    question: "Have you been shown a trading dashboard showing your financial gains?",
    weight: 5,
    options: [
      { text: "Yes, very cool", points: 5 },
      { text: "No, not at this point.", points: 1 }
    ]
  },
  {
    question: "Has your digital partner suggested or requested intimate suggestive photos?",
    weight: 2,
    options: [
      { text: "Yes", points: 3 },
      { text: "No", points: 1 }
    ]
  },
  {
    question: "Do you engage in conversation discussing romance fantasies?",
    weight: 3,
    options: [
      { text: "Yes", points: 5 },
      { text: "No", points: 1 }
    ]
  },
  {
    question: "Have you introduced your family and close friends to your new digital 'love interest'?",
    weight: 5,
    options: [
      { text: "Its our secret right now", points: 5 },
      { text: "It's scheduled for him/her to meet", points: 3 },
      { text: "Very hard to schedule with their work schedule.", points: 5 }
    ]
  },
  {
    question: "Select which describes your current personal interaction with family and friend?",
    weight: 3,
    options: [
      { text: "Increased", points: 1 },
      { text: "Decreased", points: 5 },
      { text: "Stayed the same", points: 2 }
    ]
  },
  {
    question: "How much time do you and your online partner spend communicating?",
    weight: 5,
    options: [
      { text: "Daily / 15 - 90 minutes", points: 5 },
      { text: "Weekly / 1 - 2 hour", points: 3 },
      { text: "Weekly 2 - 4 hours", points: 2 },
      { text: "Weekly over 4 hours", points: 4 }
    ]
  },
  {
    question: "Has your digital partner exhibited any aggressive behavior towards you when refusing a request?",
    weight: 5,
    options: [
      { text: "Yes", points: 5 },
      { text: "No", points: 1 }
    ]
  },
  {
    question: "Select the occupation that best describes your online partner?",
    weight: 3,
    options: [
      { text: "International Business / Finance with frequent travel", points: 3 },
      { text: "Oil Rig Workers", points: 3 },
      { text: "United States or Foreign Military", points: 3 },
      { text: "UN aide worker", points: 3 },
      { text: "CIA / FBI / NSA", points: 3 },
      { text: "Doctor / Lawyer / Accountant / Emergency Service", points: 3 },
      { text: "Emergency worker (EMT / Fireman)", points: 3 },
      { text: "None of the above", points: 3 },
      { text: "Unknown", points: 3 }
    ]
  }
];

